import { SYNC_FORM_DATA } from './';

export default (data, state) => ({
  type: SYNC_FORM_DATA,
  payload: { data, state },
});
